import React from 'react'
import UserEventEmitter from '../libs/UserEventEmitter'

const Context = React.createContext<UserEventEmitter | null>(null)

export default Context

export const UserEventEmitterProvider = Context.Provider
export const UserEventEmitterConsumer = Context.Consumer
